<template>
  <ChartBox
    class="management-benchmarks"
    :title="tableInfo.title"
    :description="tableInfo.description"
    fullwidth
  >
    <SkeletonTable
      v-if="isLoading"
      :count-table-column="5"
      :count-table-row="10"
    />

    <ErrorDefault
      :show="hasError"
      @onClickButton="getBenchmarksList()"
    />

    <div v-if="!isLoading && !hasError">
      <v-card-title>
        <v-text-field
          v-model="table.search"
          label="Buscar"
          class="mx-4"
          prepend-icon="mdi-magnify"
        />

        <div>
          <v-icon
            class="mx-8"
            @click="getBenchmarksList"
          >
            mdi-refresh
          </v-icon>
        </div>
      </v-card-title>

      <v-data-table
        :headers="table.headers"
        :items="benchmarksList"
        :search="table.search"
      >
        <template v-slot:item.createdDate="{ item }">
          {{ item.createdDateFormatted }}
        </template>

        <template v-slot:item.url="{ item }">
          <a
            v-bind="item.accessLink"
          >
            {{ item.url.slice(0, 30) + '...' }}
          </a>
        </template>

        <template v-slot:item.freePlan="{ item }">
          <v-chip
            outlined
            filter
          >
            {{ item.freePlan ? 'Sim' : 'Não' }}
          </v-chip>
        </template>

        <template v-slot:item.expiryDate="{ item }">
          <v-chip
            v-if="item.expired"
            outlined
            filter
            color="red"
          >
            Expirado em {{ item.expiryDateFormatted }}
          </v-chip>

          <span v-if="item.expiryDateFormatted && !item.expired">
            {{ item.expiryDateFormatted }}
          </span>

          <span v-if="!item.expiryDateFormatted && !item.expired">-</span>
        </template>
      </v-data-table>
    </div>
  </ChartBox>
</template>

<script>
import { format } from 'date-fns';

import { ChartBox, ErrorDefault } from 'components/base';
import { SkeletonTable } from '@/components/content/tables/SkeletonTable';
import { changePageTitle } from '@/utils';

export default {
  name: 'ManagementBenchmarks',
  components: {
    SkeletonTable,
    ChartBox,
    ErrorDefault,
  },
  data: () => ({
    table: {
      headers: [
        {
          text: 'Data e hora da criação',
          value: 'createdDate',
          align: 'center',
        },
        {
          text: 'Id do plano',
          value: 'planId',
          align: 'center',
        },
        {
          text: 'Nome do Benchmarks',
          value: 'name',
          align: 'center',
        },
        {
          text: 'User group',
          value: 'planName',
          align: 'center',
        },
        {
          text: 'URL',
          value: 'url',
        },
        {
          text: 'Período gratuito?',
          value: 'freePlan',
          align: 'center',
        },
        {
          text: 'Data expiração',
          value: 'expiryDate',
          align: 'center',
        },
      ],
      search: '',
    },
  }),
  computed: {
    isLoading() {
      return this.$store.state.setup.benchmarksList.isLoading;
    },
    hasError() {
      return this.$store.state.setup.benchmarksList.hasError;
    },
    benchmarksList() {
      return this.$store.state.setup.benchmarksList.data.map(item => ({
        ...item,
        accessLink: {
          target: '_blank',
          href: item.url,
        },
        createdDateFormatted: format(new Date(item.createdDate), 'dd/LL/yy - HH:mm'),
        expiryDateFormatted: item.expiryDate ? format(new Date(item.expiryDate), 'dd/LL/yy - HH:mm') : '',
        freePlan: Boolean(item.expiryDate),
      }));
    },
    tableInfo() {
      return {
        title: !this.isLoading ? 'Consultar Benchmarks' : '',
        description: !this.isLoading ? 'Permite buscar Benchmarks pelo user group, acessar direto pela URL e identificar se é versão gratuita ou não.' : '',
      };
    },
  },
  async mounted() {
    changePageTitle('Gerenciamento Benchmarks');
    await this.getBenchmarksList();
  },
  methods: {
    async getBenchmarksList() {
      await this.$store.dispatch('setup/getBenchmarksList');
    },
  },
};
</script>

<style lang="scss" scoped>
.management-benchmarks {
  width: 100%;
}

.v-card {
  .dialog-title {
    font-size: 16px !important;
    font-weight: 600;
    padding-bottom: 25px;
  }

  .v-btn {
    text-transform: none;
    padding: 0 25px;
  }

  .v-card__text {
    color: #ffff;
  }

  .v-alert {
    margin-top: 20px;
  }

  .v-select {
    padding-top: 15px;
    padding-bottom: 10px;
  }
}

::v-deep {
  .ds-chart-box__heading h1 {
    font-size: var(--ds-font-size-xl);
  }
}
</style>
